export class CurrentDateOutputModel {
  actualDate: Date;
  currentDate: Date;
  hasBeenSet: boolean;
}

export class CurrentDateInputModel {
  id: string;
  date: Date;
}
